/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const ModelFileStatusEnum = core.serialization.enum_(["partial", "analyzing", "analyzed", "complete", "archived", "purged", "failed"]);
